import * as Yup from 'yup';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Stack, IconButton, InputAdornment, Typography, Link } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../../components/Iconify';
import { FormProvider, RHFTextField } from '../../../components/hook-form';
import { register } from '../../../actions/auth';
import { useDispatch, useSelector } from "react-redux";
// ----------------------------------------------------------------------

export default function RegisterForm() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const { message } = useSelector(state => state.message);
  const dispatch = useDispatch();

  const RegisterSchema = Yup.object().shape({
    firstName: Yup.string().required('First name required'),
    lastName: Yup.string().required('Last name required'),
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    password: Yup.string().required('Password is required'),
    botCode: Yup.string().notRequired("Code from Telegram bot")
  });

  const defaultValues = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    botCode: ''
  };

  const methods = useForm({
    resolver: yupResolver(RegisterSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async () => {
    const firstName = methods.getValues().firstName
    const lastName = methods.getValues().lastName
    const email = methods.getValues().email
    const password = methods.getValues().password
    const botcode = methods.getValues().botCode
    if (email === '' && password === '') {
      return
    } else {

      dispatch(register(firstName, lastName, email, password, botcode))
        .then(() => {
          navigate("/apps");
          // window.location.reload();
        })
        .catch(() => {
          // setLoading(false);
        });
    }

    // navigate('/apps', { replace: true });
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <RHFTextField name="firstName" label="First name" />
          <RHFTextField name="lastName" label="Last name" />
        </Stack>

        <RHFTextField name="email" label="Email address" />

        <RHFTextField
          name="password"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton edge="end" onClick={() => setShowPassword(!showPassword)}>
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <RHFTextField name="botCode" label="Bot code" />
        <Typography variant="body2" align="center" sx={{ color: 'text.secondary', mt: 3 }}>If you use Appzybot in telegram
          <Link variant="subtitle2" to="https://t.me/appzybot" >
            Appzybot in telegram
          </Link>, press /getcode to obtain code</Typography>
        <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
          Register
        </LoadingButton>
      </Stack>
      {message && (
        <div className="form-group">
          <div className="alert alert-danger" role="alert">
            {message}
          </div>
        </div>
      )}
    </FormProvider>
  );
}
